export default {
  title: 'dark',
  background: '#222',
  color: '#fff',
  inverseColor: '#444',
  primary: '#fff',
};
